import { AppConfigResponseDto } from '@diritto/common/system/dtos/app-config.dtos';
import { FeatureFlagConfigsResponseDto } from '@diritto/common/system/dtos/feature-flag-configs.response.dto';
import { MaintenanceResponseDto } from '@diritto/common/system/dtos/maintenance.dtos';
import { Http } from '@diritto/common/utils/requester/http';

export type PlatformOSType = 'ios' | 'android' | 'macos' | 'windows' | 'web' | 'native';

export class SystemApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getMaintenance(): Promise<MaintenanceResponseDto> {
    const res = await this.http.get<MaintenanceResponseDto>(`${this.url}/systems/maintenance`);
    return res.data;
  }

  async getFeatureFlags() {
    const res = await this.http.get<FeatureFlagConfigsResponseDto>(`${this.url}/systems/feature-flag-configs`);
    return res.data;
  }

  async getAppConfig(
    os: PlatformOSType,
    osVersion: string | number,
    appVersion: string,
  ): Promise<AppConfigResponseDto> {
    const res = await this.http.get<AppConfigResponseDto>(
      `${this.url}/systems/app/config/${os}/${osVersion}/${appVersion}`,
    );
    return res.data;
  }
}
